// A league match's cancha is its Gestión field (tournament_field_id). The legacy space is
// only read as a fallback for matches that never got one.

export const matchFieldName = (match) =>
  (match?.tournament_field || match?.tournamentField)?.name || match?.space?.name || null;

export const fieldOptionLabel = (field) => field?.display_name || field?.name || "";

// Keeps the match's current value selectable when it is no longer offered
// (archived cancha or referee, or a venue detached from the competition).
export const withCurrentOption = (options, currentId, current) => {
  if (!currentId || options.some((option) => String(option.id) === String(currentId))) {
    return options;
  }

  return [...options, { id: currentId, name: current?.name || `#${currentId}` }];
};
